import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStackedBarChart100: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"stacked-bar-chart-100"} maskId="square-filled-radius-0-stroke-1-IconStackedBarChart100"><path d="M22 20H2V19H22V20ZM5 18H4V13H5V18ZM10 18H9V12H10V18ZM15 18H14V9.5H15V18ZM20 18H19V12.5H20V18ZM5 11H4V4H5V11ZM20 10.5H19V4H20V10.5ZM10 10H9V4H10V10ZM15 7.25H14V4H15V7.25Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconStackedBarChart100;
